import React, { memo, useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Typist from 'react-typist';
import styled, { css } from 'styled-components';
import { Tooltip } from 'react-tippy';
import { HelpCircle } from 'react-feather';
import Avatar from '../Global/Avatar';
import transcompiler from '../../core/transcompiler';
import { OptionContext } from '../../contexts/OptionContext';
import Mariana from '../../assets/img/mariana.png';

const nextDefault = () => { };

const StyleCustom = styled.div`${(props) => css`
    color: ${props.foreground};
  `
}`;

const DivTooltip = styled.div`
  position: absolute;
  top: 30%;
  right: -30px;
  @media (max-width: 769px) {
    position: absolute;
    top: 15%;
    right: -10px;
  }
`;

const BotDialog = ({ data = [], message = '', startDelay = 250, next = nextDefault, tooltip = '' }) => {
  const [activateTooltipHideable, setActivateTooltipHideable] = useState(true);
  const context = useContext(OptionContext);
  const { dialog, isAdmin } = context;

  const continueAction = () => {
    setActivateTooltipHideable(false);
    setTimeout(() => {
      setActivateTooltipHideable(true);
    }, 5000);
    next();
  };

  useEffect(() => {
    if (message === '') {
      continueAction();
    }
  }, []);

  return (
    <>
      {message !== ''
        && (
          <Container className="px-4 tooltip-activator">
            <Row className="mt-4" style={{ minHeight: '50px' }}>
              <Avatar
                src={dialog.botAvatar}
                rounded
                size="sm"
              />
              <Col xs="10" className="px-4" style={{ position: 'relative' }}>
                {tooltip
                  && (
                    <DivTooltip className={`${activateTooltipHideable ? 'hidden-tooltip' : ''} text-right mt-2`}>
                      <Tooltip
                        position="top"
                        html={(
                          <Row style={{ minWidth: 150 }} className="py-3">
                            <Col xs="3" className="text-center">
                              <Avatar
                                src={Mariana}
                                rounded
                                size="sm"
                              />
                            </Col>
                            <Col xs={{ span: 9 }}>
                              {tooltip}
                            </Col>
                          </Row>
                        )}
                      >
                        <HelpCircle className="help-circle" size="20" fill="#f2edff" color="#7C00FF" />
                      </Tooltip>

                    </DivTooltip>
                  )}
                <Typist avgTypingDelay={isAdmin ? 1 : 8} stdTypingDelay={isAdmin ? 1 : 4} startDelay={startDelay} onTypingDone={continueAction} key={message} cursor={{ show: false }}>
                  <StyleCustom foreground={dialog.foreground} className="dialog-typo">
                    {transcompiler(message, data)}

                  </StyleCustom>
                </Typist>

              </Col>
            </Row>
          </Container>
        )}
    </>

  );
};

export default memo(BotDialog);
